// v3.15-1096: DashboardRoute — soft guard around /dashboard.
// v3.18-1388 CRM-INT-005: The main Dashboard is now restricted to an
// explicit user-ID allow-list (CEO only).  Unauthorized visitors receive
// a hard 404 (same UX as if the route did not exist).  The backend
// enforces an identical gate at /api/dashboard/*.
import { useAuth } from '../contexts/AuthContext';
import DashboardNotFound from './DashboardNotFound';

const DashboardRoute = ({ children }) => {
  const { canViewMainDashboard, user, loading, authChecked } = useAuth();
  if (loading || (!user && !authChecked)) return null;
  if (!canViewMainDashboard()) {
    // CRM-INT-005 — do not redirect; render a 404 so the URL itself
    // reveals nothing about the Dashboard's existence.
    return <DashboardNotFound />;
  }
  return children;
};

export default DashboardRoute;
